"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SGWTConnectStorage = void 0;
/**
 * SGWTConnect data storage.
 *
 * Has the following features:
 *  - Automatic parsing of stringified data.
 *  - Prefixing of keys of stored data.
 */
var SGWTConnectStorage = /** @class */ (function () {
    function SGWTConnectStorage(hash) {
        if (hash === void 0) { hash = ''; }
        this.hash = hash;
        this.baseStorageKey = 'SGWTConnectStorage';
    }
    Object.defineProperty(SGWTConnectStorage.prototype, "storageKey", {
        get: function () {
            return this.hash ? "".concat(this.baseStorageKey, ".").concat(this.hash) : this.baseStorageKey;
        },
        enumerable: false,
        configurable: true
    });
    SGWTConnectStorage.prototype.getItem = function (key) {
        var item = localStorage.getItem("".concat(this.storageKey, ".").concat(key));
        return item === null ? null : JSON.parse(item);
    };
    SGWTConnectStorage.prototype.setItem = function (key, value) {
        localStorage.setItem("".concat(this.storageKey, ".").concat(key), JSON.stringify(value));
    };
    SGWTConnectStorage.prototype.removeItem = function (key) {
        localStorage.removeItem("".concat(this.storageKey, ".").concat(key));
    };
    SGWTConnectStorage.prototype.clearBy = function (satisfiesCondition) {
        for (var i = 0; i < localStorage.length; i += 1) {
            var key = localStorage.key(i);
            if (key && key.indexOf(this.baseStorageKey) !== -1) {
                var value = localStorage.getItem(key);
                var parsedValue = value === null ? null : JSON.parse(value);
                if (satisfiesCondition(parsedValue, key)) {
                    localStorage.removeItem(key);
                }
            }
        }
    };
    return SGWTConnectStorage;
}());
exports.SGWTConnectStorage = SGWTConnectStorage;
//# sourceMappingURL=SGWTConnectStorage.js.map